import { PropsWithChildren } from "react";
import { useConfig } from "./ConfigContext";

export default function CheckVisibleChart(
  props: { name: string } & PropsWithChildren,
) {
  const { name } = props;
  const { loggedUser } = useConfig();
  const visible = loggedUser?.company?.charts.find((a) => a.key === name);
  return <>{visible ? props.children : null}</>;
}
